





import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({})
export default class CssGroup extends Vue {
  @Prop({default: "", required: true}) public name!: string
}
